module.exports = __webpack_public_path__ + "static/media/lazienka 5.d2128333.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rooms/lazienka 5.jpg
// module id = 134
// module chunks = 0